// 模板代码块
/* <div :class="['j-map-layout', currentMeasureType]">
    <div class="j-map" :id="mapRandomId" v-bind="$attrs"/>
    <j-gis-coord v-if="showCoordinate" :point="coordinateTarget" /> // 如果不需要测量工具模块，可移除
    <slot name="control" /> // 如果不需要嵌套工具栏可移除
 </div> */

// 基本样式代码块
/* .j-map-layout {
  position: relative;
  height: 100%;
  width: 100%;
}
.j-map-layout.coordinate{
  cursor: cell;
}
.j-map-layout .j-map{
  height: 100%;
  width: 100%;
}
.j-map-layout .j-map .esri-zoom{
  display: none;
}
.esri-view .esri-view-surface--inset-outline:focus::after {
  display: none;
} */

export default {
  async created () {
    await this.createMap()
    this.JMapLoadComplete()
  },
  methods: {
    // -------------- 状态操作--------------
    // 隐藏control控件菜单
    JMapHideControlMenu () {
      this.$slots.control && this.$slots.control[0] && this.$slots.control[0].componentInstance.CtrlPopupHide()
    },
    // 统一的事件触发重置状态函数
    JMapEventResetStatus (event) {
      // 清除坐标计算弹窗
      if (this.currentMeasureType === 'coordinate') this.clearMapMeasure()
      this.currentMeasureType = ''
    },
    // -------------- 状态操作--------------

    // -------------- 点位操作--------------
    // 地图移动到选中点并高亮
    JMapDrawActivePoint (point) {
      console.log(point)
      this.graphicsActiveLayer && this.graphicsActiveLayer.removeAll()
      if (!point) return
      let url = require('../assets/point-style2.png')
      const graphic = new this.gisConstructor.Graphic({
        geometry: {
          type: 'point',
          x: point.longitude || point.x || 0,
          y: point.latitude || point.y || 0,
          spatialReference: this.view.spatialReference
        },
        symbol: {
          type: 'picture-marker',
          url, // 图标地址
          width: '44px',
          height: '44px'
        },
        attributes: {
          meta: { ...point, isActive: true }
        }
      })
      this.graphicsActiveLayer.add(graphic)
      this.JMapMovePoint(point)
    },
    // 地图画组合点位，多个图片文字组合成一个点位(moveCenter是否设置为中心点)
    async JMapDrawGroupPoint (point = {}, moveCenter = false) {
      let pointImg = require('../assets/point-style2.png') // 下方点位图片
      let descImg = require('../assets/point-style1.png') // 上方点位图片
      // let descImg = await this.ToolImageHandleFillets(point.AVATAR) // 图像裁剪成圆形
      let uuid = `${Date.now()}${parseInt(Math.random() * 100)}`
      let attributes = { id: uuid, meta: { ...point }, isGroup: true }
      let geometry = new this.gisConstructor.Point((point.longitude || point.x || 0), (point.latitude || point.y || 0), this.view.spatialReference)

      const pointGraphic = new this.gisConstructor.Graphic({
        geometry,
        symbol: { type: 'picture-marker', url: pointImg, width: '44px', height: '44px' },
        attributes
      })

      const textGraphic = new this.gisConstructor.Graphic({
        geometry,
        symbol: { type: 'text',
          color: '#456BEA',
          // haloColor: '#466BED', 外边框颜色
          // haloSize: '1px', 外边框宽度
          text: point.name || point.text || '点位文字',
          xoffset: 0,
          yoffset: 16,
          font: {
            size: 11
            // weight: 'bold'
          }
        },
        attributes
      })

      const descGraphic = new this.gisConstructor.Graphic({
        geometry,
        symbol: {
          type: 'picture-marker',
          url: descImg,
          width: '40px',
          height: '40px',
          yoffset: 44
        },
        attributes
      })

      // 符号组 --点击事件如果想同时处理一组graphic，通过循环判断id的方式，找到同一组graphic处理
      const graphicGroup = { id: uuid, graphics: [ pointGraphic, textGraphic, descGraphic ] }
      this.groupGraphicMap[uuid] = graphicGroup

      this.graphicsLayer.add(pointGraphic)
      this.graphicsLayer.add(textGraphic)
      this.graphicsLayer.add(descGraphic)
      moveCenter && this.JMapMovePoint(point)
    },
    // 地图画点位(moveCenter是否设置为中心点)
    JMapDrawPoint (point = {}, moveCenter = false) {
      let url = require('../assets/point-style1.png')
      // eslint-disable-next-line eqeqeq
      // if (point.status == 0) {
      //   url = require('../assets/point-style1.png')
      //   // eslint-disable-next-line eqeqeq
      // }
      const graphic = new this.gisConstructor.Graphic({
        geometry: {
          type: 'point',
          x: point.longitude || point.x || 0,
          y: point.latitude || point.y || 0,
          spatialReference: this.view.spatialReference
        },
        symbol: {
          type: 'picture-marker',
          url, // 图标地址
          width: '28px',
          height: '28px'
        },
        attributes: {
          meta: { ...point }
        }
      })
      this.graphicsLayer.add(graphic)
      moveCenter && this.JMapMovePoint(point)
    },
    // 通过数组渲染所有点位 ['simple', 'group']单个点、组合点
    JMapRenderPointArray (pointArr = [], type = 'simple') {
      this.JMapClearPoint()
      if (type === 'group') return pointArr.forEach((point, i) => this.JMapDrawGroupPoint(point, i === 0))
      pointArr.forEach((point, i) => this.JMapDrawPoint(point, i === 0))
    },
    // 移动到地图默认的中心点
    JMapMoveCenter () {
      this.JMapMovePoint()
    },
    // 移动到指定点
    JMapMovePoint (point = {}) {
      const { longitude, latitude, x, y } = point
      const geometry = {
        type: 'point',
        longitude: longitude || x,
        latitude: latitude || y,
        spatialReference: this.SR.wkid
      }
      this.view.center = geometry
    },
    // 清除图标点位
    JMapClearPoint () {
      this.graphicsLayer && this.graphicsLayer.removeAll()
      this.graphicsActiveLayer && this.graphicsActiveLayer.removeAll()
    },
    // -------------- 点位操作--------------

    // -------------- 事件注册--------------
    // 地图初始化加载完成
    JMapLoadComplete () {
      this.mapLoading = false
      this.$emit('load')
    },
    // 地图点击事件
    JMapClick (event) {
      if (this.currentMeasureType === 'coordinate') return this.computeCoordinate(event)
      this.$emit('click', event)
    },
    // 地图失去焦点事件
    JMapBlur (event) { this.$emit('blur', event) },
    // 地图双击事件
    JMapDoubleClick (event) {
      this.JMapEventResetStatus(event)
      this.$emit('db-click', event)
    },
    // 地图聚焦事件
    JMapFocusClick (event) { this.$emit('focus', event) },
    // 地图鼠标滚轮事件
    JMapMouseWheel (event) {
      this.JMapEventResetStatus(event)
      this.$emit('mouse-wheel', event)
    },
    // 地图拖拽、移动事件
    JMapDrag (event) {
      this.JMapEventResetStatus(event)
      this.$emit('drag', event)
    },
    // 视图点击事件（只返回包含点位的点击事件）
    JMapLayerClick (event) {
      if (event.results.length > 0) {
        let points = event.results.map(item => item.graphic.attributes)
        this.$emit('hit', points)
      }
    },
    // -------------- 事件注册--------------

    // -------------- 地图切换--------------
    // 显示电子地图
    JMapShowElectronMap () {
      this.JMapHideControlMenu()
      if (!this.mapLayerMap['电子地图']) this.buildMapLayer()
      this.showLayerById('电子地图')
    },
    // 显示影像地图
    JMapShowSimulationMap () {
      this.JMapHideControlMenu()
      if (!this.mapLayerMap['影像地图']) this.buildMapLayer()
      this.showLayerById('影像地图')
    },
    // -------------- 地图切换--------------

    // -------------- 拓展图层模块--------------
    // 显示拓展图层 - 网格
    JMapToggleExpandGridLayer (toggle = true) {
      if (!this.operationLayerMap) return console.error('未引入[layerMixins]')
      if (!this.operationLayerMap['网格']) return console.error(`配置信息operationalLayers节点中未定义['网格']`)
      this.operationLayerMap['网格'].visible = toggle
    },
    // 获取行政区划数组
    JMapGetExpandSubjectLayer () {
      if (!this.operationLayerMap) return console.error('未引入[layerMixins]')
      return this.operationLayerMap
    },
    // 显示行政区划图层 - 传参规则参照operationSublayerMap映射key 例：'网格' '区', '街道', '社区'
    JMapToggleExpandSubjectLayer (toggle = true, subject) {
      if (!this.operationSublayerMap) return console.error('未引入[layerMixins]')
      if (this.operationLayerMap[subject]) this.operationLayerMap[subject].visible = toggle
      else console.error(`配置信息operationalLayers节点中不存在对应的['${subject}'的服务],请确认传递id是否与配置信息一致,配置信息中的服务:${Object.keys(this.JMapGetExpandSubjectLayer())}`)
    },
    // -------------- 拓展图层模块--------------

    // -------------- 测量工具模块--------------
    // 测量面积
    JMapToolMeasureArea () {
      this.JMapHideControlMenu()
      if (!this.measureArea) return console.error('未引入[measureMixins]')
      this.measureArea()
    },
    // 测量坐标
    JMapToolMeasureCoordinate () {
      this.JMapHideControlMenu()
      if (!this.measureCoordinate) return console.error('未引入[measureMixins]')
      this.measureCoordinate()
    },
    // 测量距离
    JMapToolMeasureDistance () {
      this.JMapHideControlMenu()
      if (!this.measureDistance) return console.error('未引入[measureMixins]')
      this.measureDistance()
    },
    // 清除测量结果
    JMapClearMeasure () {
      if (!this.clearMapMeasure) return console.error('未引入[measureMixins]')
      this.clearMapMeasure()
    },
    // -------------- 测量工具模块--------------

    // -------------- 资源绘图模块--------------
    // 根据半径画圆范围
    JMapDrawGraphicCircleRange (centerPoint, radius) {
      const { lon, lat, longitude, latitude, x, y } = centerPoint
      const center = new this.gisConstructor.Point(x || longitude || lon, y || latitude || lat, this.SR)
      const geometry = new this.gisConstructor.Circle({ center, radius, radiusUnit: 'meters' })
      const symbol = {
        type: 'simple-fill', // autocasts as SimpleFillSymbol
        style: 'solid',
        color: [64,158,255, 0.1],
        outline: {
          color: [64,158,255, 0.1],
          width: 1
        }
      }
      const graphic = new this.gisConstructor.Graphic({ geometry, symbol })
      this.drawResourceLayer.add(graphic)
    },
    // 画点、线、面操作
    JMapDrawGraphicResources (type) {
      // type: point, polygon, polyline
      this.JMapHideControlMenu()
      if (!this.startResourceDraw) return console.error('未引入[drawMixins]')
      this.startResourceDraw(type)
    },
    // 获取绘制区域的点位信息及区域代码片段(需要先使用JMapDrawGraphicResources绘制)
    JMapGetGraphicStorage () {
      if (!this.storageGeometryPoint) return console.error('未引入[drawMixins]')
      if (!this.completeGeometry) return console.error('[startResourceDraw]未执行绘画函数,请先绘画')
      return this.storageGeometryPoint()
    },
    // 清除绘制区域
    JMapClearGraphicResources () {
      if (!this.clearResourceDraw) return console.error('未引入[drawMixins]')
      this.clearResourceDraw()
    },
    // 渲染根据Polygon字符串渲染形状
    JMapRenderPolygon (polygonString) {
      if (!this.renderPolygonString) return console.error('未引入[drawMixins]')
      this.renderPolygonString(polygonString)
    },
    // -------------- 资源绘图模块--------------
  }
}
